<script>
    import { onMount } from "svelte";

    import {
        AustralianStates,
        TitleType,
    } from "../../../../Utils/utilEnums.svelte";

    import {
        changeToSentenceCase,
        getEmailValidation,
        getPhoneValidation,
        isObjectEmpty,
    } from "../../../../Utils/utilFunctions.svelte";

    import MatchPatientDetails from "./MatchPatientDetails.svelte";

    import { apiMethods } from "../../../../Services/index.svelte";

    import { loggedInDoctorDetail } from "../../../../stores";

    import { addErrorInput } from "../../helpers/encounterUtils.svelte";

    import {
        CardLayout,
        DateInput,
    } from "../../../../Components/Common/index.svelte";

    import { searchGoogleAddress } from "../../../../Utils/DataLoaders.svelte";

    import Select from "svelte-select/Select.svelte";
    import MatchPatientEncountersDetails from "./MatchPatientEncountersDetails.svelte";

    export let patientDetails = {},
        patientContactDetails = {},
        isFromCreate = false,
        isEditDuplicate = false,
        insuranceDetails = {},
        workerCompensation,
        workerCompensationObj = {},
        trafficAuthority,
        trafficAuthorityObj = {},
        publicInPrivateObj = {},
        insuranceDetailsRef,
        disableInputScenario_ONE = false,
        disableInputScenario_TWO = false,
        UNLOCK_ALL_INPUTS = false,
        overrideValidation = false,
        enableChangeEncounterDoctor = false;

    let showAlternativeNames = false, showManualAddressEntry = false;

    export let isPatientMatched = false;

    $: isValidPhone = overrideValidation
        ? true
        : patientDetails.phone
          ? getPhoneValidation(patientDetails.phone)
          : true;

    $: isValidEmail = overrideValidation
        ? true
        : patientDetails.email
          ? getEmailValidation(patientDetails.email)
          : true;

    let matchPatientStatus = 0,
        isMatchingPatientDetails = false,
        matchPatientObj = {},
        matchEncountersResult = {};

    let errInputs = [],
        primaryLocationAddress;

    onMount(() => {
        if (isFromCreate) _updateMatchPatientStatus(0);
        else {
            _syncDefaultMatchPatientDetails();
            isPatientMatched = true;
        }
    });

    export const checkPatientDetailsValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    const syncGenderOnTitle = () => {
        const isTitleMale =
            patientDetails.title == 0 || patientDetails.title == 4;
        const isTitleFemale =
            patientDetails.title == 1 ||
            patientDetails.title == 2 ||
            patientDetails.title == 3;

        if (isTitleMale) {
            patientDetails.sex = 0;
            document.getElementById("maleCheck").checked = true;
            document.getElementById("femaleCheck").checked = false;
            document.getElementById("noGenderCheck").checked = false;
        }

        if (isTitleFemale) {
            patientDetails.sex = 1;
            document.getElementById("maleCheck").checked = false;
            document.getElementById("femaleCheck").checked = true;
            document.getElementById("noGenderCheck").checked = false;
        }

        handleMatchPatient();
    };

    const syncTitleOnGender = () => {
        // sex 0 - Male, 1 - Female, 2 - Not specified
        if (patientDetails.title == "Title") {
            if (patientDetails.sex == 0) patientDetails.title = 0;
            else if (patientDetails.sex == 1) patientDetails.title = 2;
            
            handleMatchPatient();

            return;
        }

        const isTitleMale =
            patientDetails.title == 0 || patientDetails.title == 4;
        const isTitleFemale =
            patientDetails.title == 1 ||
            patientDetails.title == 2 ||
            patientDetails.title == 3;


        switch (patientDetails.sex) {
            case 0: // Male
                if (isTitleFemale) patientDetails.title = 0; // Mr.
                break;
            case 1: // Female
                if (isTitleMale) patientDetails.title = 2; // Ms.
                break;
                
            default:
                break;
        }

        handleMatchPatient();

    };

    let matchingPatientPromise = null;
    export const handleMatchPatient = async (forceMatch = false) => {
        if (isMatchingPatientDetails) return matchingPatientPromise;

        //if (!forceMatch && isPatientMatched) return;

        const allRequiredValuesValid =
            patientDetails.firstName &&
            //patientDetails.lastName &&
            patientDetails.birthDate;

        if (!allRequiredValuesValid) return;

        if (isFromCreate || forceMatch) await matchPatientEncounters();
    };

    const matchPatient = async () => {
        isMatchingPatientDetails = true;

        _updateMatchPatientStatus(1);
        matchPatientObj = {};

        const { firstName, middleName, lastName, birthDate, title, sex } =
            patientDetails;

        const pd = {
            firstName,
            middleName,
            lastName,
            birthDate,
            title: title == "Title" ? Number(20) : title,
            // sex, // gender is not required to match patient details
        };

        // match patient details with specified gender
        if (pd.title != 20 && sex != 2) pd.sex = sex;

        matchingPatientPromise = await apiMethods.postMethod
            .matchPatient(pd, $loggedInDoctorDetail.id)
            .then((res) => {
                if (res.id) matchPatientObj = { ...res };
            });

        isMatchingPatientDetails = false;
        matchingPatientPromise = null;

        if (isObjectEmpty(matchPatientObj)) _updateMatchPatientStatus(3);
        else _updateMatchPatientStatus(2);
    };

    const matchPatientEncounters = async () => {
        isMatchingPatientDetails = true;

        _updateMatchPatientStatus(1);
        matchEncountersResult = {};

        const { firstName, middleName, lastName, birthDate, title, sex } =
            patientDetails;

        const pd = {
            firstName,
            middleName,
            lastName,
            birthDate,
            title: title == "Title" ? Number(20) : title,
            sex
        };

        matchingPatientPromise = await apiMethods.postMethod
            .matchPatientEncounters($loggedInDoctorDetail.id, pd)
            .then((res) => {
                if (!res.error) matchEncountersResult = { ...res };
            });

        isMatchingPatientDetails = false;
        matchingPatientPromise = null;

        if (isObjectEmpty(matchEncountersResult) || !matchEncountersResult.results.length) _updateMatchPatientStatus(3);
        else _updateMatchPatientStatus(2);
    };

    // HELPER FUNCTIONS
    const _updateInvalidFieldsStyle = () => {
        // Patient (firstName || middleName || lastName) and DoB are required in order to create encounters
        const patientFirstNameField = document.getElementById(
            "patientFirstNameField",
        );
        const patientMiddleNameField = document.getElementById(
            "patientMiddleNameField",
        );
        const patientLastNameField = document.getElementById(
            "patientLastNameField",
        );

        if (
            !patientFirstNameField.value &&
            !patientMiddleNameField.value &&
            !patientLastNameField.value
        ) {
            errInputs = addErrorInput(
                "patientFirstNameField",
                errInputs,
                "First name",
            );
            errInputs = addErrorInput(
                "patientMiddleNameField",
                errInputs,
                "Middle name",
            );
            errInputs = addErrorInput(
                "patientLastNameField",
                errInputs,
                "Last name",
            );
        }

        if (!isValidEmail)
            errInputs = addErrorInput("patientEmailField", errInputs);

        if (!isValidPhone)
            errInputs = addErrorInput("patientPhoneField", errInputs);

        if (!patientDetails.birthDate)
            errInputs = addErrorInput("patientBirthday", errInputs);
    };

    const _syncDefaultMatchPatientDetails = () => {
        const allRequiredValuesValid =
            patientDetails.firstName &&
            patientDetails.lastName &&
            patientDetails.birthDate;

        if (allRequiredValuesValid) _updateMatchPatientStatus(2);
    };

    const _updateMatchPatientStatus = (status = 0) =>
        (matchPatientStatus = status);

    const handleSelectPrimaryLocation = async () => {
        await apiMethods.getMethod
            .getPlaceDetailsFromGoogle(primaryLocationAddress.place_id)
            .then((res) => {
                _syncLocationDetails(res);
            });
    };

    const _syncLocationDetails = (details) => {
        patientDetails.address = details.name;

        if (details.address_components)
            for (let component of details.address_components) {
                let types = component["types"];
                if (types.includes("locality"))
                    patientDetails.city = component["long_name"];
                else if (types.includes("postal_code"))
                    patientDetails.postCode = component["long_name"];
                else if (types.includes("administrative_area_level_1"))
                    // use short name to match backend requests and sync with local constants
                    patientDetails.state = component["short_name"];
            }
    };
</script>

<CardLayout title="Patient Details" enableCollapse={false}>
    <div class="flex flex-col flex-1 p-4 w-full gap-y-4">
        <!-- title, firstName, lastName, toggle alternative name -->
        <div class="grid grid-cols-6 gap-x-2 gap-y-4 px-2 w-full">
            <select
                class="select select-bordered select-sm"
                bind:value={patientDetails.title}
                on:change={syncGenderOnTitle}
            >
                <option disabled selected>Title</option>
                {#each TitleType as title}
                    <option value={title.id}>{title.type}</option>
                {/each}
            </select>

            <input
                type="text"
                id="patientFirstNameField"
                placeholder="First name *"
                class="input w-full input-sm input-bordered"
                autocomplete="off"
                disabled={!UNLOCK_ALL_INPUTS && disableInputScenario_TWO}
                bind:value={patientDetails.firstName}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "First name *";
                }}
                on:focusout={() => {
                    patientDetails.firstName = changeToSentenceCase(
                        patientDetails.firstName,
                    );
                    handleMatchPatient();
                }}
            />

            <input
                type="text"
                id="patientMiddleNameField"
                placeholder="Middle name"
                class="input w-full input-sm input-bordered"
                autocomplete="off"
                bind:value={patientDetails.middleName}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "Middle name";
                }}
                on:focusout={() =>
                    (patientDetails.middleName = changeToSentenceCase(
                        patientDetails.middleName,
                    ))}
            />

            <input
                type="text"
                id="patientLastNameField"
                placeholder="Last name"
                class="input w-full input-sm input-bordered"
                autocomplete="off"
                bind:value={patientDetails.lastName}
                on:focus={({ target }) => {
                    target.style.outline = "";
                    target.placeholder = "Last name";
                }}
                on:focusout={() => {
                    patientDetails.lastName = changeToSentenceCase(
                        patientDetails.lastName,
                    );
                    handleMatchPatient();
                }}
            />

            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div class="cursor-pointer underline text-sm flex items-center" on:click={() => showAlternativeNames = !showAlternativeNames }>
                {#if showAlternativeNames}
                    Hide alternative names
                {:else}
                    Known by another name?
                {/if}
                
            </div>
        </div>

        <!-- alternative name -->
        {#if showAlternativeNames}
            <div class="grid grid-cols-6 gap-x-2 gap-y-4 px-2 w-full">
                <span class="col-span-1 my-auto">Alternative names:</span>

                <div class="w-full grid grid-cols-4 gap-x-2 gap-y-4 col-span-4">
                    <input
                        type="text"
                        placeholder="Alternative first name"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={patientDetails.alternativeFirstName}
                        on:focusout={() =>
                            (patientDetails.alternativeFirstName =
                                changeToSentenceCase(
                                    patientDetails.alternativeFirstName,
                                ))}
                    />

                    <input
                        type="text"
                        placeholder="Alternative middle name"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={patientDetails.alternativeMiddleName}
                        on:focusout={() =>
                            (patientDetails.alternativeMiddleName =
                                changeToSentenceCase(
                                    patientDetails.alternativeMiddleName,
                                ))}
                    />

                    <input
                        type="text"
                        placeholder="Alternative last name"
                        class="input w-full input-sm input-bordered"
                        autocomplete="off"
                        bind:value={patientDetails.alternativeLastName}
                        on:focusout={() =>
                            (patientDetails.alternativeLastName =
                                changeToSentenceCase(
                                    patientDetails.alternativeLastName,
                                ))}
                    />
                </div>
            </div>
        {/if}

        <!-- birth date, gender -->
        <div class="grid grid-cols-6 gap-x-2 gap-y-4 px-2 w-full">
            <DateInput
                placeholder="Date of Birth *"
                bind:value={patientDetails.birthDate}
                maxDate={new Date()}
                handleInput={() => handleMatchPatient()}
                id="patientBirthday"
                minDate="1900-01-01"
                showRight
                wrapperClass="input input-sm input-bordered w-full"
                wrapperClassFocus="inputFocus"
                isDisable={!UNLOCK_ALL_INPUTS &&
                    (disableInputScenario_ONE || disableInputScenario_TWO)}
            />

            <div class="flex items-center justify-between col-span-2">
                <label class="label cursor-pointer gap-x-2">
                    <input
                        type="radio"
                        name="radio-10"
                        class="radio checked:bg-secondary"
                        id="maleCheck"
                        checked={patientDetails.sex == 0}
                        disabled={!UNLOCK_ALL_INPUTS &&
                            disableInputScenario_TWO}
                        on:input={() => {
                            patientDetails = {...patientDetails, sex: 0};
                            syncTitleOnGender();
                        }}
                    />
                    <span>Male</span>
                </label>

                <label class="label cursor-pointer gap-x-2">
                    <input
                        type="radio"
                        name="radio-10"
                        class="radio checked:bg-secondary"
                        id="femaleCheck"
                        checked={patientDetails.sex == 1}
                        disabled={!UNLOCK_ALL_INPUTS &&
                            disableInputScenario_TWO}
                        on:input={() => {
                            patientDetails = {...patientDetails, sex: 1};
                            syncTitleOnGender();
                        }}
                    />
                    <span>Female</span>
                </label>

                <label class="label cursor-pointer gap-x-2">
                    <input
                        type="radio"
                        name="radio-10"
                        class="radio checked:bg-secondary"
                        id="noGenderCheck"
                        checked={patientDetails.sex == 2}
                        disabled={!UNLOCK_ALL_INPUTS &&
                            disableInputScenario_TWO}
                        on:input={() => {
                            patientDetails.sex = 2;
                            syncTitleOnGender();
                        }}
                    />
                    <span>Not specified</span>
                </label>
            </div>

            <MatchPatientEncountersDetails
                {matchPatientStatus}
                {isFromCreate}
                bind:matchResult={matchEncountersResult}
                bind:isPatientMatched
                bind:patientDetails
                bind:patientContactDetails
                bind:insuranceDetails
                bind:workerCompensation
                bind:workerCompensationObj
                bind:trafficAuthority
                bind:trafficAuthorityObj
                bind:publicInPrivateObj
                {insuranceDetailsRef}
                {enableChangeEncounterDoctor}
            />
        </div>

        <!-- email, phone -->
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <div class="grid grid-cols-6 gap-x-2 gap-y-4 px-2 w-full">
            <div class="form-control w-full">
                <input
                    type="email"
                    id="patientEmailField"
                    class="input w-full input-sm input-bordered"
                    autocomplete="off"
                    placeholder="Email"
                    bind:value={patientDetails.email}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                        target.placeholder = "Email";
                    }}
                />
                {#if !isValidEmail}
                    <label class="label">
                        <span class="label-text-alt text-error">
                            Invalid email
                        </span>
                    </label>
                {/if}
            </div>

            <div class="form-control w-full max-w-xs">
                <input
                    type="text"
                    id="patientPhoneField"
                    class="input w-full input-sm input-bordered"
                    autocomplete="off"
                    placeholder="Phone"
                    bind:value={patientDetails.phone}
                    on:blur={() =>
                        (patientDetails.phone =
                            patientDetails.phone?.replaceAll(" ", ""))}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                        target.placeholder = "Phone";
                    }}
                />
                {#if !isValidPhone && patientDetails.phone}
                    <label class="label">
                        <span class="label-text-alt text-error">
                            Invalid phone number
                        </span>
                    </label>
                {/if}
            </div>

           
        </div>

        <div class="grid grid-cols-2 w-full px-2 gap-x-2">
            <div class="flex flex-1 col-span-1">
                <Select
                    class="rounded-full max-h-[32px]"
                    bind:value={primaryLocationAddress}
                    loadOptions={searchGoogleAddress}
                    itemId="place_id"
                    label="description"
                    on:clear={() => (primaryLocationAddress = null)}
                    on:select={handleSelectPrimaryLocation}
                    noOptionsMessage="No available locations found"
                    placeholder="Start typing for address search"
                    --placeholder-color="#9CA3AF"
                    --height="32px"
                    --value-container-padding="0"
                    --padding="0 0 0 12px"
                    --font-size="14px"
                />
            </div>
             <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div class="cursor-pointer underline text-sm flex items-center" on:click={() => showManualAddressEntry = !showManualAddressEntry }>
                {#if showManualAddressEntry}
                    Hide manual address entry
                {:else}
                    Enter address manually
                {/if}
            </div>
        </div>

        <!-- address -->
        {#if showManualAddressEntry}
            <div class="grid grid-cols-6 gap-x-2 gap-y-4 px-2 w-full">
                <input
                    type="text"
                    id="patientAddressField"
                    class="input w-full input-sm input-bordered"
                    autocomplete="off"
                    placeholder="Address"
                    bind:value={patientDetails.address}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                    }}
                />

                <input
                    type="text"
                    id="patientCityField"
                    class="input w-full input-sm input-bordered"
                    autocomplete="off"
                    placeholder="City"
                    bind:value={patientDetails.city}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                    }}
                />

                <select
                    type="text"
                    id="patientStateField"
                    class="select select-bordered select-sm w-full"
                    bind:value={patientDetails.state}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                    }}
                >
                    {#each AustralianStates as state}
                        <option value={state.key.toUpperCase()}>
                            {state.name}
                        </option>
                    {/each}
                </select>

                <input
                    type="text"
                    id="patientPostcodeField"
                    class="input w-full input-sm input-bordered"
                    autocomplete="off"
                    placeholder="Postcode"
                    bind:value={patientDetails.postCode}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                    }}
                />
            </div>
        {/if}
       
    </div>
</CardLayout>

<style>
    .collapseInput {
        padding: 0 4rem !important;
        min-height: 2rem !important;
    }

    .collapse-title {
        padding-top: 4px;
        padding-left: 12px;
        padding-bottom: 0;
        min-height: 2rem !important;
    }

    .collapse-arrow .collapse-title:after {
        top: 0.5rem !important;
    }

    /* Avoid change input background color after select autocomplete option */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
</style>
